import React, { useState } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import Tutorial_data from "./Tutorial_data";
import jsonFiles from "./jsonFiles";
import CodeHeaderTutorialPage from "./CodeHeaderTutorialPage";
import "./Tutorial.css";

function TutorialHome() {
  const categories = Object.entries(Tutorial_data);
  const navigate = useNavigate();

  const [selected, setSelected] = useState(null);

  const handleClick = (e, item) => {
    e.preventDefault();

    const slug = item.id.toLowerCase();
    setSelected(item.id.trim());

    if (jsonFiles[item.id]) {
      navigate(`/tutorial/${slug}`);
    } else {
      alert(`No JSON file found for ${item.name}`);
    }
  };

  const gridClasses = [
    "col1-row1",
    "col2-row1",
    "col1-row2",
    "col2-row2",
    "col3-span",
  ];

  return (
    <div className="container">
      <h1 className="title">Tutorials</h1>

      <div className="grid">
        {categories.map(([category, items], index) => (
          <div key={index} className={`card ${gridClasses[index] || ""}`}>
            <h2 className="card-title">{category}</h2>

            <ul className="list">
              {items.map((item, idx) => (
                <li key={item.id || idx} className="list-item">
                  <a
                    href={`/tutorial/${item.id.toLowerCase()}`}
                    className="link"
                    onClick={(e) => handleClick(e, item)}
                  >
                    <span>{item.name}</span>

                    {item.badge && (
                      <span
                        className={`badge ${
                          item.badge === "HOT" ? "hot" : "new"
                        }`}
                      >
                        {item.badge}
                      </span>
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {selected && (
        <div className="selected-info">
          <h3>Last clicked:</h3>
          <p>{selected}</p>
        </div>
      )}
    </div>
  );
}

// ✅ Tutorial Details
function TutorialDetails() {
  const { name } = useParams();

  const id = Object.keys(jsonFiles).find(
    (key) => key.toLowerCase() === name.toLowerCase(),
  );

  if (!id) return <h2>❌ Tutorial not found</h2>;

  const data = jsonFiles[id];

  // Get display name and id from Tutorial_data
  const foundItem = Object.values(Tutorial_data)
    .flat()
    .find((item) => item.id === id);

  const tutorialName = foundItem?.name.trim() || id;
  const tutorialId = foundItem?.id || id;

  return (
    <CodeHeaderTutorialPage
      cleanName={id}
      data={data}
      tutorialName={tutorialName}
      tutorialId={tutorialId}
    />
  );
}

// ✅ Main Tutorial Component
export default function Tutorial() {
  return (
    <Routes>
      <Route path="/" element={<TutorialHome />} />
      <Route path=":name" element={<TutorialDetails />} />
    </Routes>
  );
}
